export default "__VITE_ASSET__C53KLLsq__"